"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
    _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _moment = _interopRequireDefault(require("moment")),
    _classnames = _interopRequireDefault(require("classnames")),
    _uiKit = require("@devsta/ui-kit"),
    _AssetPreview = _interopRequireDefault(require("../../AssetPreview")),
    _utils = require("../utils");

require("../styles/_video-details.scss");

var getDate = function getDate(a) {
  return (0, _moment["default"])(parseInt(a, 10)).format("YYYY/MM/DD [at] hh:mm A");
};

function VideoDetails(a) {
  var b = a.className,
      c = a.title,
      d = a.assetId,
      e = a.embedCode,
      f = a.updatedAt,
      g = a.showContentSource;
  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])("post-video-details", b)
  }, d ? _react["default"].createElement(_AssetPreview["default"], {
    assetId: d,
    width: "75px",
    height: "75px",
    borderRadius: 0,
    hideFileTypeIcon: !0
  }) : _react["default"].createElement(_uiKit.Image, {
    defaultImageIcon: e ? "embed" : "projects",
    width: "75px",
    height: "75px",
    defaultIconColour: "russian",
    defaultIconSize: 35
  }), _react["default"].createElement("div", null, _react["default"].createElement(_uiKit.Text, {
    noMargin: !0
  }, c), g && (d || e ? _react["default"].createElement(_uiKit.Text, {
    placeholder: !0
  }, (0, _utils.getInspirationContentSource)({
    assetId: d,
    embedCode: e
  })) : _react["default"].createElement(_uiKit.Text, {
    caption: !0
  }, "Upload, Source & Video Embed available")), f && _react["default"].createElement(_uiKit.Text, {
    timestamp: !0,
    noMargin: "bottom"
  }, getDate(f))));
}

var _default = (0, _react.memo)(VideoDetails);

exports["default"] = _default;